import { render, staticRenderFns } from "./sub_carrinho.vue?vue&type=template&id=76f9708b&"
import script from "./sub_carrinho.vue?vue&type=script&lang=js&"
export * from "./sub_carrinho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports